import { useQuery } from "@tanstack/react-query"
import { RefreshCcw } from "lucide-react"

import { Button } from "@/components/ui/button.tsx"
import { getRuns } from "@/features/datapoints/api/report/getRuns.ts"
import ReportRunsTable from "@/features/datapoints/components/report/ReportRunsTable.tsx"

export default function ReportRuns() {
  const { data, refetch, isPending, isFetching } = useQuery({
    queryKey: ["reportRuns"],
    queryFn: getRuns,
  })

  return (
    <>
      <Button variant="outline" onClick={() => refetch()} disabled={isFetching}>
        Refresh <RefreshCcw className={isFetching ? "animate-spin" : ""} />
      </Button>
      <div className="rounded-md shadow-sm border mt-2 overflow-hidden">
        <ReportRunsTable data={data || []} isLoading={isPending} />
      </div>
    </>
  )
}
